import { Howl } from 'howler';
import { errorManager } from '@powerplay/common';
import { AudioManager } from './';
export class Audio {
    loader;
    audioName;
    spriteAudioName = '';
    audioObject;
    howl = undefined;
    isSprite = false;
    buffer = undefined;
    randomizeSprite = false;
    spriteNames = [];
    subset = false;
    retryCounter = 0;
    prefix = '';
    constructor(name, object, loader) {
        this.loader = loader;
        this.audioName = name;
        this.audioObject = object;
        this.prefix = `${AudioManager.PATH_ASSETS}/audio/${object.category}/${name}`;
        this.selectAudio(this.prefix, object, loader);
    }
    selectAudio(prefix, object, loader) {
        if (object?.playDirect) {
            loader.load(`${prefix}${object.version || ''}.mp3`, (buffer) => {
                this.buffer = buffer;
            }, undefined, undefined);
        }
        else if (object?.sprite) {
            console.log('loading sprite howl');
            this.howl = new Howl({
                src: `${prefix}${object.version || ''}.mp3`,
                loop: object.loop,
                volume: object.volume,
                rate: object.rate,
                sprite: object.sprite,
                onloaderror: this.onHowlerLoadError
            });
            this.spriteNames = Object.keys(object.sprite);
            if (object.randomizeSprite)
                this.randomizeSprite = true;
            if (object.subset)
                this.subset = true;
            this.isSprite = true;
        }
        else {
            console.log('loading nonsprite howl');
            this.howl = new Howl({
                src: `${prefix}${object.version || ''}.mp3?`,
                loop: object.loop,
                volume: object.volume,
                rate: object.rate,
                onloaderror: () => {
                    this.onHowlerLoadError();
                }
            });
        }
    }
    onHowlerLoadError() {
        const url = `${this.prefix}${this.audioObject?.version || ''}.mp3`;
        this.retryCounter += 1;
        if (this.retryCounter <= 3) {
            this.selectAudio(this.prefix, this.audioObject, this.loader);
        }
        else {
            throw new Error(errorManager.showBox(`We could not download all assets! (${url})`));
        }
    }
}
//# sourceMappingURL=Audio.js.map